module.exports = __webpack_public_path__ + "img/p6.ed4ea92d.png";